import { useAuth } from "../components/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Spinner, Alert, Container, Row, Col } from "react-bootstrap";

function ProtectedRouteWithPerm({ children, requiredPerm }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Row>
          <Col className="text-center">
            <Spinner animation="border" variant="primary" role="status" />
            <div className="mt-3 text-muted">Bilgiler yükleniyor...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPerm && !user.permissions.includes(requiredPerm)) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Row>
          <Col>
            <Alert variant="warning" className="text-center shadow-sm">
              Bu sayfayı görüntüleme yetkiniz yok.
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }

  return children;
}

export default ProtectedRouteWithPerm;
